import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { FaTimes } from 'react-icons/fa';
import { Modal } from 'react-bootstrap';
import { isValidPkMobile, getDeviceTokenValue } from '../../../../functions/Functions';
import './DigitalMenuItemModal.css';

const CustomerInfoModal = ({ isOpen, onClose, customerInfo, onSave, branchId }) => {
  const { id, tableName, orderType } = useParams();
  
  const [name, setName] = useState('');
  const [phnNo, setPhnNo] = useState('');

  useEffect(() => {
    if (isOpen) {
      setName(customerInfo?.name || '');
      setPhnNo(customerInfo?.phn_no || '');
    }
  }, [isOpen, customerInfo]);

  const handleSave = () => {
    if (!isValidPkMobile(phnNo)) {
      return false
    }
    onSave(name, phnNo);
    onClose();
  };


  return (
    <Modal show={isOpen} onHide={onClose} centered dialogClassName="customer-modal-dialog mx-auto" contentClassName="border-0 shadow-lg rounded-xlg overflow-hidden">
      <div className="modal-header py-2 d-flex justify-content-between align-items-center">
        <div className='d-flex align-items-center'>
          <h5 style={{fontSize: "18px"}} className="modal-title font-weight-bold text-dark mb-0">Customer Info</h5>
          {!orderType ? <div className='ml-2' style={{fontSize:"13px"}}>{`ID: ${getDeviceTokenValue(branchId)}`}</div> : ""}
        </div>

        <button type="button" className="btn shadow-none p-0 m-0 bg-transparent border-0 d-flex align-items-center justify-content-center" onClick={onClose}>
          <FaTimes size={20} />
        </button>
      </div>
      <div className="modal-body p-3">
        
        <div className="form-group mb-3">
          <label className="text-slate customer-modal-label font-weight-bold mb-1">Name</label>
          <input 
            type="text" 
            className="form-control customer-modal-input bg-light border-0 py-2 rounded-sm"
            placeholder="Enter your name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        
        <div className="form-group customer-modal-label mb-4">
          <label className="text-slate font-weight-bold mb-1">Phone Number</label>
          <input 
            type="tel" 
            className="form-control customer-modal-input bg-light border-0 py-2 rounded-sm"
            placeholder="Enter your phone number"
            value={phnNo}
            onChange={(e) => setPhnNo(e.target.value)}
          />
        </div>

        <button 
          className="btn text-white customer-modal-label w-100 py-2 rounded-pill shadow-sm font-weight-bold mb-2"
          style={{ backgroundColor: '#0f172a' }}
          onClick={handleSave}
        >
          Save Details
        </button>
      </div>
    </Modal>
  );
};

export default React.memo(CustomerInfoModal);
